/**
 * View mode tabs - Stories vs Epics
 * Story 198: View and filter stories in backlog
 * Story 227: Add story creation
 */

import './ViewTabs.css';

export type ViewMode = 'backlog' | 'epics';

interface ViewTabsProps {
  activeView: ViewMode;
  onViewChange: (view: ViewMode) => void;
  onCreateStory?: () => void;
  onCreateEpic?: () => void;
}

export function ViewTabs({ activeView, onViewChange, onCreateStory, onCreateEpic }: ViewTabsProps) {
  return (
    <div className="view-tabs">
      <button
        className={`view-tabs__tab ${activeView === 'backlog' ? 'view-tabs__tab--active' : ''}`}
        onClick={() => onViewChange('backlog')}
        type="button"
      >
        Stories
        {onCreateStory && (
          <span
            className="view-tabs__add-btn"
            onClick={(e) => { e.stopPropagation(); onCreateStory(); }}
            role="button"
            aria-label="Create new story"
            title="Create new story"
          >
            <svg viewBox="0 0 16 16" fill="currentColor" width="12" height="12">
              <path d="M7.75 2a.75.75 0 0 1 .75.75V7h4.25a.75.75 0 0 1 0 1.5H8.5v4.25a.75.75 0 0 1-1.5 0V8.5H2.75a.75.75 0 0 1 0-1.5H7V2.75A.75.75 0 0 1 7.75 2z" />
            </svg>
          </span>
        )}
      </button>
      <button
        className={`view-tabs__tab ${activeView === 'epics' ? 'view-tabs__tab--active' : ''}`}
        onClick={() => onViewChange('epics')}
        type="button"
      >
        Epics
        {onCreateEpic && (
          <span
            className="view-tabs__add-btn"
            onClick={(e) => { e.stopPropagation(); onCreateEpic(); }}
            role="button"
            aria-label="Create new epic"
            title="Create new epic"
          >
            <svg viewBox="0 0 16 16" fill="currentColor" width="12" height="12">
              <path d="M7.75 2a.75.75 0 0 1 .75.75V7h4.25a.75.75 0 0 1 0 1.5H8.5v4.25a.75.75 0 0 1-1.5 0V8.5H2.75a.75.75 0 0 1 0-1.5H7V2.75A.75.75 0 0 1 7.75 2z" />
            </svg>
          </span>
        )}
      </button>
    </div>
  );
}
